export function getPreferenceValue(
  preferences: unknown,
  key: string,
): unknown {
  let parsed: unknown = preferences;
  if (typeof preferences === "string") {
    try {
      parsed = JSON.parse(preferences);
    } catch {
      return undefined;
    }
  }
  if (!parsed || typeof parsed !== "object") return undefined;
  return (parsed as Record<string, unknown>)[key];
}
